import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatFontSize = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8 1.75H2.75a1 1 0 0 0-1 1v2m6.25-3h5.25a1 1 0 0 1 1 1v2M8 1.75v16.5m0 0H5.75m2.25 0h2.25M15.125 10H12.5a.5.5 0 0 0-.5.5v1m3.125-1.5h2.625a.5.5 0 0 1 .5.5v1M15.125 10v8.25m0 0H14m1.125 0h1.125"
	})]
});
const ForwardRef = forwardRef(SvgFormatFontSize);
export { ForwardRef as ReactComponent };
